module.exports = "/_next/static/images/blurred_orb-35d13b96c8923092ab2dc908b9c72180.png";